module.exports = __webpack_public_path__ + "img/question-mark-pink.636fbf87.svg";